import GroupDiscountIcon from '../../../assets/icons/group-discount/Featured icon.svg';
import type { GroupDiscountData } from '../types/discount.types';

export interface GroupDiscountProps {
    data?: GroupDiscountData;
}

const GroupDiscount = ({ data = {} }: GroupDiscountProps) => {
    const heading = data.groupDiscountTitle ?? '';
    const subheading = data.groupDiscountDescription ?? '';

    return (
        <div
            className="flex items-center bg-transparent w-full gap-[20px] min-h-[44px] opacity-100 box-border"
        >
            <div
                className="flex-shrink-0 flex items-center justify-center w-[44px] h-[44px] min-w-[44px]"
            >
                <img
                    src={GroupDiscountIcon}
                    alt="Group discount"
                    className="w-11 h-11"
                />
            </div>

            <div className="flex-1 min-w-0">
                <h3 className="font-['Noto_Sans'] text-[16px] font-semibold leading-[24px] text-[#002B66] m-0">
                    {heading}
                </h3>
                <p className="m-0 font-['Noto_Sans'] text-[12px] font-normal leading-[18px] text-[rgba(0,43,102,0.70)] overflow-hidden text-ellipsis">
                    {subheading}
                </p>
            </div>
        </div>
    );
};

export default GroupDiscount;
